<template>
  <h1 class="font-mono font-bold mt-24 text-indigo-500">{ <span class="text-white">My Skills</span> }</h1>
  <div class="mt-12 xl:w-1/2 sm:w-2/3 w-4/5 mx-auto">
    <div class="w-full shadow-2xl subpixel-antialiased rounded h-auto bg-slate-900  border-black mx-auto">
      <div class="flex items-center h-8 rounded-t  dark:bg-slate-900 border-b border-slate-50 text-center text-black" id="headerTerminal">
        <div class="flex ml-2 items-center text-center border-red-900 bg-red-500 shadow-inner rounded-full w-3 h-3" id="closebtn"></div>
        <div class="ml-2 border-yellow-900 bg-yellow-500 shadow-inner rounded-full w-3 h-3" id="minbtn"></div>
        <div class="ml-2 border-green-900 bg-green-500 shadow-inner rounded-full w-3 h-3" id="maxbtn"></div>
        <div class="mx-auto pr-16" id="terminaltitle">
          <p class="text-center text-sm dark:text-white">Terminal</p>
        </div>
      </div>
      <div class="mb-5 p-6 h-auto text-green-200 font-mono text-xs bg-slate-900" id="BGCard">
        <div class="skills">
          <div class="details">
            <span id="word">HTML</span>
            <span id="Load">LOADING...</span>
          </div>
          <div class="bar">
            <div id="jQuery-bar"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Skills"
}
</script>

<style scoped>

</style>